<template>
  <section>
    <div class="addOilCard-item-box" v-if="!oilcardList.length">
      <div class="addOilCard-item-title-0">
        <span class="title">油卡</span>
        <span class="btn">
          <span class="primary cur" @click="showAddOilCardDialog"
            >添加油卡</span
          >
        </span>
      </div>
    </div>
    <div
      class="addOilCard-item-box"
      v-for="(item, index) in oilcardList"
      :key="index"
    >
      <div class="addOilCard-item-title">
        <span class="title">油卡{{ index + 1 }}</span>
        <span class="btn">
          <span class="primary cur" v-if="!index" @click="showAddOilCardDialog"
            >添加油卡</span
          >
          <span
            class="primary cur"
            v-if="!item.cardBalanceAdd"
            @click="recharge(item, index)"
            >充值</span
          >
          <span
            class="error cur"
            v-if="item.cardBalanceAdd"
            @click="recharge(item, index)"
            >修改</span
          >
          <span
            class="error cur"
            v-if="item.cardBalanceAdd"
            @click="clear(item, index)"
            >清除</span
          >
          <span class="error cur" @click="remove(index)">移除</span>
        </span>
      </div>
      <OilcardForm
        ref="oilcardForm"
        :cardNum="item.cardNum"
        :cardTypeName="item.cardTypeName"
        :cardBalance="item.cardBalance"
      />
    </div>
    <AddOilCardDialog ref="addOilCardDialog" @sub="getOilCardNum" />
    <RechargeOilCardDialog
      ref="rechargeOilCardDialog"
      @sub="getRechargeAmount"
    />
    <!-- <button @click="getData">测试</button> -->
  </section>
</template>

<script>
import { getCardInfoByCardNum } from 'api/operate';
import OilcardForm from './oilcardForm';
import AddOilCardDialog from './addOilCardDialog';
import RechargeOilCardDialog from './rechargeOilCardDialog';
export default {
  components: {
    OilcardForm,
    AddOilCardDialog,
    RechargeOilCardDialog,
  },
  model: {
    prop: 'oilcardList',
    event: 'cc',
  },
  props: {
    oilcardList: {
      default: () => ([]),
    },
  },
  methods: {
    getData () {
      this.sub();
    },
    // 充值
    recharge (item, index) {
      this.$refs.rechargeOilCardDialog.show({
        item,
        index,
      });
    },
    // 移除
    remove (index) {
      this.oilcardList.splice(index, 1);
    },
    // 清除
    clear (item, index) {
      const cardInfo = JSON.parse(JSON.stringify(this.oilcardList[index]));
      cardInfo.cardBalance = `${cardInfo.cardBalanceBackup}`;
      cardInfo.cardBalanceAdd = '';
      this.$set(this.oilcardList, index, cardInfo);
    },
    // 弹出添加油卡弹窗
    showAddOilCardDialog () {
      // 弹出添加油卡的输入框弹窗
      this.$refs.addOilCardDialog.show();
    },
    // 弹出充值油卡弹窗
    showRechargeDialog () {
      this.$refs.rechargeOilCardDialog.show();
    },
    // 获取油卡卡号
    async getOilCardNum (oilCardNum) {
      const res = await getCardInfoByCardNum(oilCardNum);
      if (!res.failed) {
        if (res.items && res.items.length) {
          const cardInfo = res.items[0];
          this.oilcardList.push({
            cardNum: `${cardInfo.oilCarNum}`,
            cardTypeName: cardInfo.cardTypeName,
            cardBalance: `${cardInfo.cardBalance / 100}`,
            cardBalanceBackup: `${cardInfo.cardBalance / 100}`,
            // 充值了多少钱
            cardBalanceAdd: '',
            cardType: cardInfo.cardType,
          });
          this.$refs.addOilCardDialog.hide();
        } else {
          this.$message({
            type: 'info',
            message: '该油卡不存在或无效！',
          });
        }
      }
    },
    // 获取充值金额
    getRechargeAmount (res) {
      const cardInfo = JSON.parse(JSON.stringify(this.oilcardList[res.index]));
      // 原本的余额加上输入的充值余额
      cardInfo.cardBalance = `${cardInfo.cardBalanceBackup} + ${res.rechargeAmount}`;
      cardInfo.cardBalanceAdd = `${res.rechargeAmount}`;
      this.$set(this.oilcardList, res.index, cardInfo);
    },
    sub () {
      let oilCardArray = [];
      if (this.oilcardList.length) {
        for (let item of this.oilcardList) {
          oilCardArray.push(`${item.cardNum},${item.cardBalanceAdd || '0'},${item.cardType},${item.isAdd || true}`);
        }
      }
      const formData = {
        oilcardList: this.oilcardList,
        // 提交所需格式
        oilCardStr: oilCardArray.join(';'),
      };
      return formData;
    },
  },
};
</script>

<style lang="scss" scoped>
.addOilCard-item-box {
  .addOilCard-item-title-0 {
    margin-left: 50px;
    margin-bottom: 15px;
    .title {
      font-size: 14px;
      color: #888;
      display: inline-block;
      width: 60px;
      text-align: right;
      padding-right: 10px;
    }
    .btn {
      span {
        margin-right: 16px;
      }
    }
  }
  .addOilCard-item-title {
    margin-left: 50px;
    margin-bottom: 15px;
    .title {
      font-size: 16px;
      display: inline-block;
      width: 70px;
    }
    .btn {
      span {
        margin-right: 16px;
      }
    }
  }
}
</style>
